/**
 * Bundles
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';
import Modal from '../../components/Modal';
// context
import AuthContext from '../../authContext';
import InvoiceModal from './components/modal';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getInvoicesAction,
  createInvoiceActions,
  getInvoiceWithIdAction,
  getInvoicesLogs,
  updateInvoiceActions,
} from './saga/actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLogs,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectInvoicesList,
  makeSelectAllInvoicesList,
  makeSelectInvoicesFile,
} from './saga/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import List from './list';
// import CSV from './csv';
// import ExelExport from './components/exelExport';

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Grid,
  MenuItem,
  Select,
  FormControl,
} from '@material-ui/core';

// Icon
import {
  mdiAccountOutline,
  mdiStateMachine,
  mdiHomeSearchOutline,
  mdiCalendar,
} from '@mdi/js';

// Helper
import {
  removeEmptyValueObject,
} from '../../utils/helpers';

// Type
import { Props, SelectorProps } from './saga/interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
// import Edit from './components/edit';

// apis
import handleError from '../../utils/handleError';
import useQuery from '../../utils/hook/useQuery';
import invoicesRepository from 'client-sdk/src/Repository/invoices-repository';
import handleNotfication from '../../utils/handleNotfication';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: 0,
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
  })
);

const Bill: FunctionComponent<Props> = (props: Props) => {
  const [filters, setFilters] = useState([] as Filter[]);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100
  } as any);
  const [invoiceModal, setInvoiceModal] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [modalType, setModalType] = useState('' as string);
  const [file, setFile] = useState<any>(null);
  const [invoiceId, setInvoiceId] = useState();
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contains': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  useEffect(() => {
    getInvoices();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getInvoices = () => {
    const { page, size } = filtersValues;
    props.allInvoicesDispatch({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };
  const handleAddInvoice = payload => {
    if (modalType == 'edit') {
      props.updateInvoiceDispatch(payload);
    } else {
      props.createInvoiceDispatch(payload);
    }
    handleCloseInvoiceModal();
  };
  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'partnerName.contains',
        label: 'نام شرکت',
        icon: mdiAccountOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت',
        data: ['CREATED', 'PAID', 'NOT_PAID', 'CASH_PAID', 'CANCELED'],
        translateType: 'invoice',
        icon: mdiStateMachine,
      },
      {
        type: 'date-picker',
        id: 'created.greaterThanOrEqual',
        label: 'تاریخ ایجاد از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'created.lessThanOrEqual',
        label: '  تا تاریخ ایجاد ',
        icon: mdiCalendar,
      },
      {
        type: 'input',
        id: 'subject.contains',
        label: 'بابت',
        icon: mdiHomeSearchOutline,
      },
    ]);
  };
  let headCells = [];

  headCells = [
    {
      id: 'partnerName',
      label: 'نام شرکت',
      type: 'input',
    },
    { id: 'amount', label: 'مبلغ فاکتور (ریال)', type: 'input' },
    { id: 'amount', label: 'مبلغ قابل پرداخت (ریال)', type: 'input' },
    { id: 'id', label: 'شناسه', type: 'input' },
    {
      id: 'created',
      label: 'تاریخ ایجاد',
      type: 'date-picker',
    },
    { id: 'subject', label: 'بابت', type: 'input' },
    {
      id: 'status',
      label: 'وضعیت',
      type: 'checkbox',
      data: ['CREATED', 'PAID', 'NOT_PAID', 'CASH_PAID'],
    },
  ];
  const head = { headCells };

  const handleOpenConfirmUpdateState = async (data: {
    id: number;
    body: any;
  }) => {
    try {
      const action = {
        payload:
          { id: data.id, body: { status: data.body } }
      }
      await invoicesRepository.updateInvoiceStatus(action);
      handleNotfication("وضعیت صورتحساب با موفقیت تغییر کرد", "success")
      getInvoices();
    } catch (error) {
      handleError(error);
    }
  };

  const removeInvoice = async (id: number) => {
    try {
      await invoicesRepository.removeInvoice({ payload: { id } });
      handleNotfication("صورتحساب با موفقیت حذف شد", "success")
      getInvoices();
    } catch (error) {
      handleError(error);
    }
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleOpenEdit = id => {
    setInvoiceId(id);
    setInvoiceModal(true);
    setModalType('edit');
    props.invoiceDispatch({
      id,
      page: 0,
      size: 1000,
    });
  };

  const handleCloseInvoiceModal = () => {
    setInvoiceModal(false);
    setModalType('');
    getInvoices()
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h6" component="div">
            {`صورتحساب ها`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 100,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه پرداخت',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid xs={3} item container alignItems="center">
          {props.loading ? (
            ''
          ) : (
            <>
              <div className={classes.subtitle}>{`تعداد کل صورتحساب ها:`}</div>
              <div>
                &nbsp;
                <b>{`${props.count}`}</b>
              </div>
            </>
          )}
        </Grid>
        <Grid container item xs={9} direction="row-reverse">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setInvoiceModal(true);
              setModalType('add');
            }}
            size={'large'}
          >{`صدور فاکتور`}</Button>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                handleOpenEdit={handleOpenEdit}
                data={props.invoicesList}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onDelete={removeInvoice}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(props.count / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
      <Modal
        maxWidth="sm"
        onClose={handleCloseInvoiceModal}
        open={invoiceModal}
        title={
          modalType == 'add' ? (
            <Typography
              variant="h6"
              style={{ textAlign: 'center', marginTop: '20px' }}
            >
              صدور فاکتور
            </Typography>
          ) : (
            modalType == 'edit' && (
              <Typography
                variant="h6"
                style={{ textAlign: 'center', marginTop: '20px' }}
              >
                {`ویرایش فاکتور ${invoiceId}`}
              </Typography>
            )
          )
        }
        content={
          props.invoice && (
            <InvoiceModal
              data={props.invoice}
              addInvoice={handleAddInvoice}
              type={modalType}
              onClose={handleCloseInvoiceModal}
              editId={invoiceId}
            />
          )
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  loading: makeSelectLoading(),
  count: makeSelectCountList(),
  error: makeSelectError(),
  invoice: makeSelectInvoicesList(),
  invoicesList: makeSelectAllInvoicesList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    allInvoicesDispatch: (payload: Object) =>
      dispatch(getInvoicesAction(payload)),
    createInvoiceDispatch: (payload: Object) =>
      dispatch(createInvoiceActions(payload)),
    invoiceDispatch: (payload: Object) =>
      dispatch(getInvoiceWithIdAction(payload)),
    logDispatch: (payload: Object) => dispatch(getInvoicesLogs(payload)),
    updateInvoiceDispatch: (payload: Object) =>
      dispatch(updateInvoiceActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Bill);
